module.exports = {
  UNLIMITED: "unlimited",
  PRO: "pro",
  GOLD: "gold",
};
